import { Typography } from "@mui/material";

const typographyStyle = {
  fontFamily: "Poppins",
  fontSize: "12px",
  lineHeight: "16px",
  fontWeight: 500,
};

export const clientTableContent = [
  {
    id: "clientOrderNum",
    columnLabel: "CLIENT ORDER NUMBER",
    render: (row: any) => (
      <Typography
        color="#051433"
        sx={typographyStyle}
        // onClick={() => setVisibility(true)}
        onClick={() => {}}
      >
        {row.clientOrderNum}
      </Typography>
    ),
  },
  {
    id: "vendor",
    columnLabel: "VENDOR",
    render: (row: any) => (
      <Typography
        color="#051433"
        sx={typographyStyle}
        // onClick={() => setVisibility(true)}
        onClick={() => {}}
      >
        {row.vendor}
      </Typography>
    ),
  },
  {
    id: "model",
    columnLabel: "MODEL",
    render: (row: any) => (
      <Typography
        color="#051433"
        sx={typographyStyle}
        // onClick={() => setVisibility(true)}
        onClick={() => {}}
      >
        {row.model}
      </Typography>
    ),
  },
  {
    id: "chargerDetails",
    columnLabel: "CHARGER DETAILS",
    render: (row: any) => (
      <Typography
        color="#051433"
        sx={typographyStyle}
        // onClick={() => setVisibility(true)}
        onClick={() => {}}
      >
        {row.chargerDetails}
      </Typography>
    ),
  },
  {
    id: "serialId",
    columnLabel: "SERIAL ID",
    render: (row: any) => (
      <Typography
        color="#051433"
        sx={typographyStyle}
        // onClick={() => setVisibility(true)}
        onClick={() => {}}
      >
        {row.serialId}
      </Typography>
    ),
  },
  {
    id: "chargerId",
    columnLabel: "CHARGER ID",
    render: (row: any) => (
      <Typography
        color="#051433"
        sx={typographyStyle}
        // onClick={() => setVisibility(true)}
        onClick={() => {}}
      >
        {row.chargerId}
      </Typography>
    ),
  },
];
